import {inject, Injectable} from "@angular/core";
import {SellerPosition} from "../models/seller-position";
import {map, Observable} from "rxjs";
import {DealApiService, SellerPositionAndDealId} from "../generated-sources/api/deal";

@Injectable({
    providedIn: "root"
})
export class SellerPositionService {
    private readonly dealApiService = inject(DealApiService)

    constructor( ) {
    }

    public getSellerPositionsForDealAndFundValuation(dealId: number, fundValuationId: number): Observable<SellerPosition> {
        return this.dealApiService.getSellerPositionForDealAndFundValuation(dealId, fundValuationId);
    }

    public getSellerPositionsForDeal(dealId: number): Observable<SellerPosition[]> {
        return this.dealApiService.getSellerPositionsForDeal(dealId);
    }

    public getSellerPosition(dealId: number, sellerPositionId: number, fundValuationId: number): Observable<SellerPosition> {
        return this.dealApiService.getSellerPosition(dealId, sellerPositionId, fundValuationId);
    }

    public getSellerPositionForFundValuation(fundValuationId: number, dataset: string): Observable<SellerPositionAndDealId> {
        return this.dealApiService.getSellerPositionForFundValuation(fundValuationId, dataset);
    }

    public save(dealId: number, fundValuationId: number, sellerPosition: SellerPosition): Observable<SellerPosition> {
        const result: Observable<SellerPosition> = !!dealId && !!fundValuationId && !!sellerPosition.id
            ? this.dealApiService.updateSellerPosition(dealId, sellerPosition.id, fundValuationId, sellerPosition)
            : this.dealApiService.createSellerPosition(dealId, fundValuationId, sellerPosition);
        return result.pipe(map((sellerPositionDto: SellerPosition) => sellerPositionDto));
    }

    public updateSellerPositions(dealId: number, sellerPositions: SellerPosition[]): Observable<SellerPosition[]> {
        return this.dealApiService.updateSellerPositions(dealId, sellerPositions);
    }
}
